import { Action, Selector, Store } from '@ngrx/store';
import { FormControl, NgControl } from '@angular/forms';
import {
  DestroyRef,
  Directive,
  Inject,
  inject,
  Input,
  OnInit,
  Self,
} from '@angular/core';

import { connectToStore } from './ngrx';

import { Control } from '@iss/core/forms';

@Directive({
  selector: '[woConnectToStore][formControl],[woConnectToStore][formControlName],[woConnectToStore][ngModel]',
  standalone: true,
})
export class ConnectToStoreDirective<TValue, TState> implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly store = inject<Store<TState>>(Store);

  @Input({ required: true, alias: 'woConnectToStore' }) public selector!: Selector<TState, TValue>;
  @Input({ required: true, alias: 'woConnectToStoreAction' }) public actionCreator!: (value: TValue) => Action;

  public constructor(
    @Self() @Inject(NgControl) public readonly control: Control<FormControl<TValue>>,
  ) {}

  public ngOnInit(): void {
    connectToStore<TValue>(
      this.destroyRef,
      this.control.control,
      this.store.select(this.selector),
      value => this.store.dispatch(this.actionCreator(value)),
    );
  }
}
